import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3;
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ContextSetting } from '../../store/setting';
import { Input } from './Input';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Warpper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0.8rem 0.8rem 0.8rem 0.8rem;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  gap: 0.5rem;\n"])));
var ItemWarpper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n"])));
var InputMini = styled(Input)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  max-width: 60px;\n"])));
var Item = props => {
  var {
    label,
    children,
    paddingLeft
  } = props;
  var style = {
    paddingLeft
  };
  return /*#__PURE__*/_jsxs(ItemWarpper, {
    children: [/*#__PURE__*/_jsx("label", {
      style: style,
      children: label
    }), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
};
var colorInputStyle = {
  padding: 0
};
export var SettingView = () => {
  var {
    state,
    dispatch
  } = useContext(ContextSetting);
  var {
    fontSize,
    width,
    offsetX,
    offsetY,
    blurRadius,
    spreadRadius,
    color,
    padding,
    enableShadow,
    borderRadius,
    lineHighlight,
    lineNumbers,
    disableTitle
  } = state;
  return /*#__PURE__*/_jsxs(Warpper, {
    children: [/*#__PURE__*/_jsx(Item, {
      label: "Window Style",
      children: /*#__PURE__*/_jsxs("select", {
        value: state.windowStyle,
        onChange: ev => dispatch({
          windowStyle: ev.target.value
        }),
        children: [/*#__PURE__*/_jsx("option", {
          value: "none",
          children: "none"
        }), /*#__PURE__*/_jsx("option", {
          value: "Windows",
          children: "Windows"
        }), /*#__PURE__*/_jsx("option", {
          value: "MacOS",
          children: "MacOS"
        })]
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Width",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        placeholder: "auto",
        min: "250",
        value: width,
        onChange: ev => dispatch({
          width: ev.target.value
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Padding",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        placeholder: "auto",
        value: padding,
        onChange: ev => dispatch({
          padding: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Font Size",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: fontSize,
        onChange: ev => dispatch({
          fontSize: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Line Numbers",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "checkbox",
        checked: lineNumbers,
        onChange: ev => dispatch({
          lineNumbers: ev.target.checked
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Line Highlight",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "checkbox",
        checked: lineHighlight,
        onChange: ev => dispatch({
          lineHighlight: ev.target.checked
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Title",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "checkbox",
        checked: disableTitle,
        onChange: ev => dispatch({
          disableTitle: ev.target.checked
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Border Radius",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: borderRadius,
        onChange: ev => dispatch({
          borderRadius: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Shadow",
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "checkbox",
        checked: enableShadow,
        onChange: ev => dispatch({
          enableShadow: ev.target.checked
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Offset X",
      paddingLeft: 10,
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: offsetX,
        onChange: ev => dispatch({
          offsetX: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Offset Y",
      paddingLeft: 10,
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: offsetY,
        onChange: ev => dispatch({
          offsetY: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Blur Radius",
      paddingLeft: 10,
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: blurRadius,
        onChange: ev => dispatch({
          blurRadius: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Spread Radius",
      paddingLeft: 10,
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "number",
        value: spreadRadius,
        onChange: ev => dispatch({
          spreadRadius: Number(ev.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(Item, {
      label: "Color",
      paddingLeft: 10,
      children: /*#__PURE__*/_jsx(InputMini, {
        type: "color",
        value: color,
        style: colorInputStyle,
        onChange: ev => dispatch({
          color: ev.target.value
        })
      })
    })]
  });
};